<div class="d-flex justify-content-center position-relative px-3">
    <img class="gauge img-fluid" src="assets/speaking-score-gauge-2.png">
    <img *ngIf="showPointer" class="needle img-fluid position-absolute start-50 translate-middle-x" src="assets/speaking-score-needle.png" [style.--rotationString]="rotationString">
</div>